import faker from '@faker-js/faker';

const assetCode = 'EUR';

const getStatisticItem = () => ({
    [assetCode]: {
        updated_at: faker.date.recent().toISOString(),
        amount: faker.finance.amount(1000, 10000, 2),
        currency_code: assetCode
    }
})

export const getStaticStatistic = () => ({
    finance: {
        pending_invoices: getStatisticItem(),
        volumes_monthly: getStatisticItem(),
        volumes_overall: getStatisticItem()
    }
})